module.exports = __webpack_public_path__ + "img/general_staff_annual_check_up_tc.d3517062.png";